require('./bootstrap')

// dayjs
window.dayjs = require('dayjs');
import 'dayjs/locale/ru';

dayjs.locale('ru');
const _dayjs = (date, c) => {
    if (typeof date === 'string') date = date.replace(/-/g, '/')
    return dayjs(date, c)
}
export default _dayjs
window._dayjs = _dayjs;
Vue.filter('dayjs', function (value, format) {
    return dayjs(value).format(format);
})

const settings = {
    apiKey: '',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
}
import YmapPlugin from 'vue-yandex-maps'
Vue.use(YmapPlugin, settings)

// Components
const Calculator = require('./components/Calculator.vue').default;
const Offices = require('./components/Offices.vue').default;
const Location = require('./components/Location.vue').default;

Vue.component('calculator', Calculator);
Vue.component('offices', Offices);
Vue.component('location', Location);

// Vuex
import Vuex from 'vuex';

Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'

// Store
const store = new Vuex.Store({
    state: {
        calcSum: null,
        calcPeriod: null,
        gettingMoneyMethod: null
    },
    getters: {},
    mutations: {
        calcSum(state, payload) {
            state.calcSum = payload;
        },
        calcPeriod(state, payload) {
            state.calcPeriod = payload;
        },
        gettingMoneyMethod(state, payload) {
            state.gettingMoneyMethod = payload;
        }
    },
    plugins: [
        createPersistedState({ storage: window.localStorage, key: 'vuex-landing' }),
    ],
})

const mainApp = new Vue({
    store,
    methods: {
        redirectToProfile: function (data) {
            window.location.href = window.profileUrl;
        }
    }
}).$mount('#app')
